import { render, staticRenderFns } from "./TechSection.vue?vue&type=template&id=29fe1f71&scoped=true"
import script from "./TechSection.vue?vue&type=script&lang=js"
export * from "./TechSection.vue?vue&type=script&lang=js"
import style0 from "./TechSection.vue?vue&type=style&index=0&id=29fe1f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe1f71",
  null
  
)

export default component.exports